import { useToastAction } from "@metaforcelabs/metaforce-core"
import GenericModal from "../../../components/Modals/genericModal"
import { useState, useEffect } from "react";
import { exportText, getGroups } from "../../../api/textlibrary";

export default function ExportDialog({ open, setOpen, onClose }) {
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [exportJustTemplate, setExportJustTemplate] = useState(false);
    const [groupOptions, setGroupOptions] = useState([]);
    const [error, setError] = useState();

    const exportAction = useToastAction();

    useEffect(() => {
        if (open) {
            loadGroups();
        }
    }, [open]);

    const loadGroups = async () => {
        try {
            const groups = await getGroups();
            const options = [
                { id: "", name: "All" },
                ...groups.map(group => ({ id: group.id, name: group.name }))
            ];
            setGroupOptions(options);
        } catch (err) {
            console.error("Failed to load groups:", err);
        }
    };

    const handleClose = () => {
        onClose();
        setSelectedGroupId("");
        setExportJustTemplate(false);
        setError(undefined);
    }

    const handleExport = async () => {
        exportAction.execute(async () => {
            try {
                const exportData = {
                    ExportJustTemplate: exportJustTemplate
                };

                if (selectedGroupId) {
                    exportData.GroupId = selectedGroupId;
                }

                const selectedGroup = groupOptions.find(g => g.id === selectedGroupId);
                const groupName = selectedGroup ? selectedGroup.name : "All";
                const templateSuffix = exportJustTemplate ? "-template" : "";
                const fileName = `export-${groupName.toLowerCase()}${templateSuffix}.json`;

                await exportText({
                    data: exportData,
                    fileName: fileName
                });

                setError(undefined);
                handleClose();
            } catch (err) {
                if (err.response?.status === 400) {
                    setError(err.response?.data?.Message);
                } else {
                    setError("Failed to export texts");
                }
            }
        }, "Failed to export texts");
    }

    const handleGroupChange = (e) => {
        setSelectedGroupId(e.target.value);
    }

    const handleTemplateCheckboxChange = (e) => {
        setExportJustTemplate(e.target.checked);
    }

    return (
        <GenericModal
            open={open}
            onClose={() => {
                if (exportAction.isExecuting)
                    return;
                handleClose();
            }}
            onConfirm={() => handleExport()}
            onCancel={() => {
                if (exportAction.isExecuting)
                    return;
                handleClose();
            }}
            confirmButtonText={"Export"}
            cancelButtonText={"Close"}
            showCancelButton={true}
            disabled={exportAction.isExecuting}
        >
            <div className="">
                <h3 className="text-left text-lg font-medium py-2">Export texts</h3>
                <hr></hr>
                {
                    error && <div className="pt-3 text-red-500">{error}</div>
                }
                
                <div className="py-4 space-y-4">
                    {/* Groups dropdown */}
                    <div className="py-4 flex items-center justify-between">
                        <label className="text-sm font-medium text-gray-700 mb-2 flex-grow flex flex-col pr-4">
                            Groups: 
                        </label>
                        <select
                            value={selectedGroupId}
                            onChange={handleGroupChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            disabled={exportAction.isExecuting}
                        >
                            {groupOptions.map(group => (
                                <option key={group.id} value={group.id}>
                                    {group.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Export just template checkbox */}
                    <div className="flex items-center">
                        <input
                            id="exportJustTemplate"
                            type="checkbox"
                            checked={exportJustTemplate}
                            onChange={handleTemplateCheckboxChange}
                            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            disabled={exportAction.isExecuting}
                        />
                        <label htmlFor="exportJustTemplate" className="ml-2 block text-sm text-gray-700">
                            Export just template (not texts)
                        </label>
                    </div>
                </div>

                {exportAction.isExecuting && (
                    <div className="inline-flex items-center text-indigo-700 pt-2 pb-6">
                        <svg className="animate-spin -ml-1 mr-3 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span>Exporting...</span>
                    </div>
                )}
            </div>
        </GenericModal>
    )
}